module.exports = __webpack_public_path__ + "static/media/31.0be9af28.png";